import React from 'react';
import { useLocation } from 'react-router-dom';

const PAGE_TITLES: Record<string, string> = {
  '/': 'Dashboard',
  '/matches': 'Gestion des matchs',
  '/bars': 'Gestion des bars',
  '/diffusions': 'Gestion des diffusions',
  '/stories': 'Stories Instagram',
  '/logs': 'Historique des actions',
};

interface Props {
  adminName: string;
  connected: boolean;
}

export function Header({ adminName, connected }: Props) {
  const location = useLocation();
  const title = PAGE_TITLES[location.pathname] || 'ONPITCH';

  return (
    <header className="header">
      <h1 className="header-title">{title}</h1>
      <div className="header-right">
        <div className="connection-indicator">
          <span className={`conn-dot ${connected ? 'green' : 'orange'}`} />
          <span style={{ fontSize: '12px', color: 'var(--text-muted)' }}>
            {connected ? 'Connecté' : 'Connexion...'}
          </span>
        </div>
        <span style={{ fontSize: '13px', color: 'var(--text-muted)' }}>{adminName}</span>
      </div>
    </header>
  );
}
